import { render, staticRenderFns } from "./SellersModal.vue?vue&type=template&id=794fc932&scoped=true&"
import script from "./SellersModal.vue?vue&type=script&lang=js&"
export * from "./SellersModal.vue?vue&type=script&lang=js&"
import style0 from "./SellersModal.vue?vue&type=style&index=0&id=794fc932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794fc932",
  null
  
)

export default component.exports